module.exports = __webpack_public_path__ + "assets/img/18_1843.fc43a434.jpg";